module.exports = __webpack_public_path__ + "static/media/questionImage.68bdf8e0.svg";